module.exports = __webpack_public_path__ + "static/logo-f9dd014771570986ec385a0b62c85d0e.svg";